import Footer from "@components/Footer";
import Header from "@components/Header";
import Banner from "@components/Banner";
import Breadcrumb from "@components/Breadcrumbs";
import StayInpired from "@components/Home/StayInspired";
import ThaoDienHaven from "@components/Discover/ThaoDienHaven";
import Recommendation from "@components/Discover/Recommendation";
import Divider from "@components/Discover/Divider";
import Locations from "@components/Discover/Locations";
import SaigonThough from "@components/Discover/SaigonThough";
import SectionArticle from "@components/Discover/SectionArticle";
import SectionArticleMobile from "@components/Discover/SectionArticleMobile";
import LearnDiscover from "@components/Discover/LearnDiscover";
import Events from "@components/Discover/Events";
import OurLocation from "@components/Discover/OurLocation";
import { useRouteContext } from "@providers/RouteProvider";
import { useTranslationContext } from "@providers/TranslationProvider";
import { usePageContext } from "@providers/PageProvider";
import helper from "@utils/helper";
import styles from "./Discover.module.scss";
import _ from "lodash";

const View = () => {
  const { router } = useRouteContext();
  const { Trans } = useTranslationContext();
  const { pageData, hotel } = usePageContext();
  const banner = helper.formatBanner(pageData);
  const footer = helper.renderDetailsFooter(hotel);
  // const bannerFooter = meetingPage.formatBannerFooter(pageData);
  const titleProps = {
    className: "text-white",
  };
  const descProps = {
    className: "text-white",
  };
  return (
    <div className="" data-scroll-container>
      <Header />
      <Banner
        type={"high"}
        image={_.get(banner, "image")}
        title={_.get(banner, "title")}
        titleProps={titleProps}
        descProps={descProps}
        description={
          <>
            <Trans
              i18nKey={"Discover.description"}
              components={[<br key="trans_0" />]}
            />
          </>
        }
      />
      <Breadcrumb data={router.breadcrumbs("discover", { hotel })} />
      <ThaoDienHaven />
      <Divider />
      <Recommendation />
      <Locations />
      <SaigonThough />
      <SectionArticle className={styles.sectionArticle} />
      <SectionArticleMobile className={styles.sectionArticleMobile} />
      <LearnDiscover />
      <Events />
      <OurLocation />
      <StayInpired border="none" />
      <Footer
        data={{
          name: footer.name,
          address: footer.address,
          email: footer.email,
          phone: footer.phone,
        }}
      />
    </div>
  );
};

export default View;
